module.exports = __webpack_public_path__ + "img/AdobeStock_76085076.ac46be91.jpeg";